import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing12,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { BoxList } from 'approot/shared/design-system/box/box.style';
import {
  green1,
  green6,
  green9,
  grey1,
  grey10,
  grey2,
  grey5,
  red1,
  red6,
  red9,
} from 'approot/shared/styles/colours.style';
import { font24, fontWeightBold } from 'approot/shared/styles/typography.style';
import {
  borderRadius8,
  standardFocusState,
  standardInsetBoxShadow,
} from 'approot/shared/styles/borders.style';
import {
  baseDragItemBaseColour,
  DRAG_ITEM_SIZE,
} from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag.style';

export const InteractiveResponsCategoriseOptions = styled(BoxList)`
  padding: 0 ${rem(spacing12)};
`;

export const InteractiveResponseCategoriseOptionItem = styled.button<{
  $isCorrect?: boolean;
  $isAnswered?: boolean;
}>`
  ${font24}
  ${standardFocusState}

  border: 1px solid ${grey5};
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  color: ${grey10};
  font-weight: ${fontWeightBold};
  height: auto;
  list-style: none;
  margin-bottom: ${rem(spacing16)};
  padding: ${rem(spacing12)} ${rem(spacing24)};
  width: 100%;

  &:active {
    background-image: none;
    ${standardInsetBoxShadow}
  }

  &:hover {
    cursor: pointer;
  }

  ${({ $isAnswered }) =>
    $isAnswered &&
    `
    background-color: ${grey2};
    border-color: ${grey10};
  `}

  ${({ $isCorrect }) =>
    $isCorrect === true &&
    `
    background-color: ${green1};
    border-color: ${green9};
  `}

  ${({ $isCorrect }) =>
    $isCorrect === false &&
    `
    background-color: ${red1};
    border-color: ${red9};
  `}
`;

type InteractiveResponseCategoriseTileProps = {
  $isInFocus?: boolean;
  $isCorrect?: boolean;
  $baseColour?: string | null;
};
export const InteractiveResponseCategoriseTile = styled.div<InteractiveResponseCategoriseTileProps>`
  background-color: ${grey1};
  border: 1px solid ${grey10};
  border-radius: ${rem(borderRadius8)};
  box-shadow: 4px 4px 4px -4px #162233;
  position: relative;
  z-index: 3;
  width: ${rem(DRAG_ITEM_SIZE)};
  height: ${rem(DRAG_ITEM_SIZE)};

  ${baseDragItemBaseColour}
  ${standardFocusState}

  ${({ $isInFocus }) =>
    $isInFocus
      ? `
    transform: scale(${200 / DRAG_ITEM_SIZE});
    transform-origin: -2px -2px;
  `
      : `
    transform: scale(${80 / DRAG_ITEM_SIZE});
    transform-origin: -2px -2px;
  `}

  ${({ $isCorrect }) =>
    $isCorrect === true &&
    `
    box-shadow: 0 0 1px 4px ${green6};
    transition: box-shadow 500ms ease; 
  `}
  ${({ $isCorrect }) =>
    $isCorrect === false &&
    `
    box-shadow: 0 0 1px 4px ${red6};
    transition: box-shadow 500ms ease; 
  `}
`;

export const InteractiveResponseCategoriseTileInner = styled.div`
  border-radius: ${rem(borderRadius8)};
  overflow: hidden;
  position: relative;
  height: 100%;
  width: 100%;
`;

type InteractiveResponseCategoriseTileLiProps = {
  $isInFocus?: boolean;
};
export const InteractiveResponseCategoriseTileLi = styled.li<InteractiveResponseCategoriseTileLiProps>`
  ${({ $isInFocus }) =>
    $isInFocus
      ? `
    min-width: ${rem(200)};
    min-height: ${rem(200)};
  `
      : `
    min-width: ${rem(80)};
    min-height: ${rem(80)};
  `}
`;
